
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { models } from 'powerbi-client';
import { PowerbiPageComponent } from 'src/app/powerbi-page/powerbi-page.component';
import { DaterangeService } from 'src/core/services/daterange.service';
import { ModalService } from 'src/core/services/modal.service';
import { PowerbiService } from 'src/core/services/powerbi.service';
import { SelectedContentService } from 'src/core/services/selectedcontent.service';
import { SelectedsystemService } from 'src/core/services/selectedsystem.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-error',
  imports: [PowerbiPageComponent],
  templateUrl: './error.component.html',
  styleUrl: './error.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ErrorComponent {

  constructor(
    private powerbiService: PowerbiService,
    private selectedSystemService: SelectedsystemService,
    private modalService: ModalService,
    private daterangeService: DaterangeService,
    private selectedContentService: SelectedContentService
  ) { }

  @Input() type: string = "widget";

  embedToken: string;
  powerbifilters;
  deviceInformation;

  ngOnInit(): void {

    this.modalService.$modalChanged.subscribe((modal) => {

      let filtervalue = modal.filter || [];

      if (modal && modal.modal === 'error' && modal.open === true) {

        let reportId = environment.modals.fleet.reportId;
        let groupId = environment.modals.fleet.groupId;

        this.powerbiService.getEmbedToken({ reportId, groupId })

          .subscribe({
            next: (token) => {

              const datefilter: models.IRelativeDateFilter = {
                $schema: "https://powerbi.com/product/schema#relativeDate",
                target: { table: "Dates", column: "Date" },
                operator: models.RelativeDateOperators.InLast,
                timeUnitsCount: this.daterangeService.$selectedRangeSystemHealth.value,        // <- your dynamic X (a number)
                timeUnitType: models.RelativeDateFilterTimeUnit.Days,
                includeToday: true,
                filterType: models.FilterType.RelativeDate
              }

              if (filtervalue.length === 0) {

                this.powerbifilters = [
                  {
                    $schema: "https://powerbi.com/product/schema#basic",
                    target: {
                      table: "Nodes",
                      column: "Serial Number",
                    },
                    operator: "In",
                    values: [this.selectedContentService.currentSystem.SerialNumber],
                  },
                  datefilter,
                ];

              }

              else {

                this.powerbifilters = [
                  {
                    $schema: "https://powerbi.com/product/schema#basic",
                    target: {
                      table: "Nodes",
                      column: "Serial Number",
                    },
                    operator: "In",
                    values: [this.selectedContentService.currentSystem.SerialNumber],
                  },
                  datefilter,
                  {
                    $schema: "https://powerbi.com/product/schema#basic",
                    target: {
                      table: "Event Codes",
                      column: "Subsystem",
                    },
                    operator: "In",
                    values: [filtervalue[0].value],
                  }
                ];

              }
              this.embedToken = token[0]["accessToken"];
            }
          });
      }
    });
  }


  getReportModal() {
    return {
      reportId: environment.modals.fleet.reportId,
      groupId: environment.modals.fleet.groupId,
      pageId: environment.modals.fleet.events.pageid
    }

  }

}

